import React, { useContext, useState, useEffect } from 'react';
import { updateDadosProjeto, Projeto } from '@app/api/projeto';
import {
  Widget,
  FormSubmitButton,
  FormatText,
  FormInput,
  FormSelect,
  FormTextArea,
  CrudContext,
  FormDatePicker,
  FormRangePicker,
  FormMonthPicker,
} from '@digital/ui';
import { StatusProjeto } from '@app/api/statusProjeto';
import { hasPermission } from '@app/helpers/permissions';
import { SelectValue } from 'antd/lib/select';
import { TipoProjetoFase } from '@app/api/tipoProjetoFase';
import { StatusRfa } from '@app/api/statusRfa';
import moment from 'moment';
import { dateFormat, dateFormatUS, ISOStringFormat, monthYearFormat } from '@app/helpers/dateTimeFormats';
import { date } from 'yup';

interface FormDadosProjetoProps {
  selectedItem: Projeto;
  statusList: StatusProjeto[];
  statusRfaList: StatusRfa[];
  fasesList: TipoProjetoFase[];
  projetoUpdate: Projeto;
  handler: () => any;
}

const FormDadosProjeto = (props: FormDadosProjetoProps) => {
  const { statusList, fasesList, selectedItem, projetoUpdate, handler, statusRfaList } = props;
  const [currentStatus, setCurrentStatus] = useState<string>();
  const [selectdProjeto, setSelectdProjeto] = useState<Projeto>(projetoUpdate);

  const [inicioBaselineState, setInicioBaselineState] = useState();
  const [fimBaselineState, setFimBaselineState] = useState();
  const [inicioRealForcastState, setInicioRealForcastState] = useState();
  const [terminoRealForcastState, setTerminoRealForcastState] = useState();
  const [terminoRealForcastStateDateTime, setTerminoRealForcastStateDateTime] = useState<Date>();
  const [dataConclusao, setDataConclusao] = useState<moment.Moment>();


  const [inicioRealState, setInicioRealState] = useState();
  const [terminoRealState, setTerminoRealState] = useState();

  useEffect(() => {
    if (selectedItem && statusList) {

      const current = (statusList && statusList.length > 0 && statusList.find(s => s.id === selectedItem.statusProjetoId).nome) || '';
      setCurrentStatus(current);

      if (selectedItem.inicioBaseline) {
        setInicioBaselineState(convertStringToMoment(selectedItem.inicioBaseline));
      } else {
        setInicioBaselineState(null);
      }

      setTerminoRealForcastStateDateTime(selectedItem.terminoRealForcastDateTime);

      if (selectedItem.fimBaseline) {
        setFimBaselineState(convertStringToMoment(selectedItem.fimBaseline));
      } else {
        setFimBaselineState(null);
      }

      if (selectedItem.inicioRealForcast) {
        setInicioRealForcastState(convertStringToMoment(selectedItem.inicioRealForcast));
      } else {
        setInicioRealForcastState(null);
      }

      if (selectedItem.terminoRealForcast) {
        setTerminoRealForcastState(convertStringToMoment(selectedItem.terminoRealForcast));
      } else {
        setTerminoRealForcastState(null);
      }


      if (selectedItem.inicioReal) {
        setInicioRealState(convertStringToMoment(selectedItem.inicioReal));
      } else {
        setInicioRealState(null);
      }

      if (selectedItem.terminoReal) {
        setTerminoRealState(convertStringToMoment(selectedItem.terminoReal));
      } else {
        setTerminoRealState(null);
      }

      if (selectedItem.dataConclusao) {
        setDataConclusao(moment(selectedItem.dataConclusao));
      } else {
        setDataConclusao(null);
      }

    }
  }, [selectedItem, statusList]);

  const convertStringToMoment = (dateString: string) => {
    return moment(dateString, "MM/YYYY");
  }

  const handleUpdate = async () => {
    if (selectedItem) {
    
      await updateDadosProjeto(selectedItem).then(resp => {
        if (resp.valid) handler();
        return resp;
      });
    }
  };

  const handleChangeStatus = (value: SelectValue) => {
    if (value) {
      selectedItem.statusProjetoId = String(value);

      if (statusList !== undefined && statusList.length > 0) {
        const current = (statusList && statusList.find(s => s.id === value).nome) || '';
        if (current !== 'Concluído') {
          selectedItem.dataConclusao = '';
          setDataConclusao(null);
        }
        setCurrentStatus(current);
      }
    }
  };

  const handleChangeStatusRfa = (value: SelectValue) => {
    if (value) {
      selectedItem.statusRfaId = String(value);
    }
  };

  const handleChangeFase = (value: SelectValue) => {
    if (value) selectedItem.tipoProjetoFaseId = String(value);
  };

  const handleChangeEscopoPluriAnual = (value: any) => {
    if (value) selectedItem.escopoPluriAnual = String(value.target.value);
  };

  const handleChangeRequisitoAmbiental = (value: any) => {
    if (value) selectedItem.requisitoAmbiental = String(value.target.value);
  };

  const handleChangeDate = (value: moment.Moment) => {
    const ano = value.get('year');
    const mes = value.get('month');
    const dia = value.get('date');
    const novoValor = moment().set({ 'year': ano, 'month': mes, 'date': dia });
    setDataConclusao(novoValor);
    selectedItem["dataConclusao"] = novoValor.format("MM/DD/YYYY");
  };

  return (
    <Widget
      title="Dados do Projeto"
      actions={[
        hasPermission(['PROJETO_ABA_GERAL_EDITAR']) && (
          <FormSubmitButton type="primary" onClick={handleUpdate}>
            <FormatText id="ui.commons.save" uppercase />
          </FormSubmitButton>
        ),
      ]}>
      <FormInput label="Número" name="numero" span={3} disabled />
      <FormInput label="Nome" name="nome" span={3} disabled />
      <FormInput label="Código" name="codigo" span={3} disabled />
      <FormInput label="Situação" name="situacao" span={3} disabled />
      <FormDatePicker
        label="Data de Conclusão"
        name="dataConclusao"
        format="DD/MM/YYYY"
        span={3}
        value={dataConclusao}
        disabled={currentStatus !== 'Concluído'}
        required={currentStatus === 'Concluído'}
        onChange={value => {
          if (value)
            handleChangeDate(value);
        }}
      />
      <FormSelect
        label="Tipo"
        name="tipoProjetoFaseId"
        placeholder="Selecione uma opção"
        options={fasesList && fasesList.map(a => ({ text: a.nome, value: a.id.toString() }))}
        span={3}
        optionFilterProp="children"
        onChange={value => handleChangeFase(value)}
      />
      <FormSelect
        label="Status"
        name="statusProjetoId"
        placeholder="Selecione uma opção"
        options={statusList && statusList.map(a => ({ text: a.nome, value: a.id.toString() }))}
        span={3}
        optionFilterProp="children"
        onChange={value => handleChangeStatus(value)}
      />
      <FormSelect
        label="Status RFA"
        name="statusRfaId"
        placeholder="Selecione uma opção"
        options={statusRfaList && statusRfaList.map(a => ({ text: a.nome, value: a.id.toString() }))}
        span={3}
        optionFilterProp="children"
        onChange={value => handleChangeStatusRfa(value)}
      />
      <FormTextArea
        label="Escopo Plurianual"
        name="escopoPluriAnual"
        onInput={value => handleChangeEscopoPluriAnual(value)}
        rows={3}
        span={12}
      />
      <FormTextArea
        label="Requisitos Ambientais"
        name="requisitoAmbiental"
        onInput={value => handleChangeRequisitoAmbiental(value)}
        rows={3}
        span={12}
      />

      <FormMonthPicker
        label="Inicio Baseline"
        name="inicioBaselineDateTime"
        allowClear={true}
        format={monthYearFormat}
        span={2}
        onChange={(e) => {
          if (e) {
            setInicioBaselineState(moment(e));
            selectedItem.inicioBaselineDateTime = new Date(moment(e).format(dateFormatUS));
          } else {
            setInicioBaselineState(undefined);
            selectedItem.inicioBaselineDateTime = undefined;
          }
        }}
      />

      <FormMonthPicker
        label="Término Baseline"
        name="fimBaselineDateTime"
        allowClear={true}
        format={monthYearFormat}
        span={2}
        onChange={(e) => {
          if (e) {
            setFimBaselineState(moment(e));
            selectedItem.fimBaselineDateTime = new Date(moment(e).format(dateFormatUS));
          } else {
            setFimBaselineState(undefined);
            selectedItem.fimBaselineDateTime = undefined;
          }
        }}
      />

      <FormMonthPicker
        label="Início real"
        name="inicioRealDateTime"
        allowClear={true}
        format={monthYearFormat}
        span={2}
        onChange={(e) => {
          if (e) {
            setInicioRealState(moment(e));
            selectedItem.inicioRealDateTime = new Date(moment(e).format(dateFormatUS));
          } else {
            setInicioRealState(undefined);
            selectedItem.inicioRealDateTime = undefined;
          }
        }}
      />

      <FormMonthPicker
        label="Término real"
        name="terminoRealDateTime"
        allowClear={true}
        format={monthYearFormat}
        span={2}
        onChange={(e) => {
          if (e) {
            setTerminoRealState(moment(e));
            selectedItem.terminoRealDateTime = new Date(moment(e).format(dateFormatUS));
          } else {
            setTerminoRealState(undefined);
            selectedItem.terminoRealDateTime = undefined;
          }
        }}
      />


      <FormMonthPicker
        label="Início Forecast"
        name="inicioRealForcastDateTime"
        allowClear={true}
        format={monthYearFormat}
        span={2}
        onChange={(e) => {
          if (e) {
            setInicioRealForcastState(moment(e));
            selectedItem.inicioRealForcastDateTime = new Date(moment(e).format(dateFormatUS));
          } else {
            setInicioRealForcastState(undefined);
            selectedItem.inicioRealForcastDateTime = undefined;
          }
        }}
      />


      <FormMonthPicker
        label="Término Forecast"
        name="terminoRealForcastDateTime"
        allowClear={true}
        format={monthYearFormat}
        span={2}
        onChange={(e) => {
          if (e) {
            setTerminoRealForcastState(moment(e));
            selectedItem.terminoRealForcastDateTime = new Date(moment(e).format(dateFormatUS));
          } else {
            setTerminoRealForcastStateDateTime(undefined);
            selectedItem.terminoRealForcastDateTime = undefined;
          }
        }}
      />

    </Widget>
  );
};

export default FormDadosProjeto;
